import React from 'react';
import { PerformanceData } from '../types';
import { collapsedViewStyles } from '../styles';

interface CollapsedViewProps {
  requests: PerformanceData[];
  onExpand: () => void;
}

export const CollapsedView: React.FC<CollapsedViewProps> = ({ requests, onExpand }) => {
  const totalRequests = requests.length;
  const totalTime = requests.reduce((acc, r) => acc + r.durationTotal, 0);
  const totalBulletWarnings = requests.reduce((acc, r) => acc + (r.bulletWarnings?.length || 0), 0);

  return (
    <div style={collapsedViewStyles.container} onClick={onExpand}>
      <span style={collapsedViewStyles.timeIndicator}>{(totalTime / 1000).toFixed(2)} s</span>
      <span style={collapsedViewStyles.requestCount}>+{totalRequests}</span>
      {totalBulletWarnings > 0 && <span style={collapsedViewStyles.warningCount}>⚠{totalBulletWarnings}</span>}
    </div>
  );
};
